export default "__VITE_ASSET__BRCtuoex__";